import React, { createRef, useEffect } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import FrontSrc from '@cover/kreativitaetstarten/front';
import BackSrc from '@cover/kreativitaetstarten/back';
import starSrc from '@cover/kreativitaetstarten/star.svg';

const Front = styled(FrontSrc)`
	position: absolute;
	top: 0%;
	left: 0%;
	z-index: 999;

	.front_svg__circle {
		opacity: 0;
	}
`
const Back = styled(BackSrc)`
	position: absolute;
	top: 0%;
	left: 0%;

	.back_svg__circle {
		opacity: 0;
	}
`

const AnimatedLayer = styled.img`
	position: absolute;
	transform-origin: center center;
	z-index: 999;
`
const Star1 = styled(AnimatedLayer)`
	height: 5%;
	top: 22%;
	left: 3%;
`
const Star2 = styled(AnimatedLayer)`
	height: 5%;
	top: 24%;
	left: 52.5%;
`
const Star3 = styled(AnimatedLayer)`
	height: 4.7%;
	top: 36%;
	left: 29.5%;
`
const Star4 = styled(AnimatedLayer)`
	height: 5%;
	top: 49%;
	left: 71%;
`


const KreativitaetStarten = ({ play }) => {
	const front = createRef();
	const back = createRef();
	const star1 = createRef();
	const star2 = createRef();
	const star3 = createRef();
	const star4 = createRef();

	useEffect(() => {
		if (!play) return
		// back
		const backAll = back.current.querySelector('#back_typo')
		const backF = back.current.querySelector('#back_svg__F')
		const backFStroke = back.current.querySelector('#back_svg__f-stroke')
		const backR = back.current.querySelector('#back_svg__r')
		const backE = back.current.querySelector('#back_svg__e')
		const backI = back.current.querySelector('#back_svg__i')
		const backIDot = back.current.querySelector('#back_svg__dot-i')

		const blackStar1 = back.current.querySelector('#back_svg__black-star1')
		const blackStar2 = back.current.querySelector('#back_svg__black-star2')
		const blackStar3 = back.current.querySelector('#back_svg__black-star3')
		const blackStar4 = back.current.querySelector('#back_svg__black-star4')
		const blackStar5 = back.current.querySelector('#back_svg__black-star')

		// front
		const frontAll = front.current.querySelector('#front_typo')
		const frontEnt = front.current.querySelector('#front_svg__ent')
		const frontEntStroke = front.current.querySelector('#front_svg__t-stroke')
		const frontF = front.current.querySelector('#front_svg__f')
		const frontAlten = front.current.querySelector('#front_svg__alten')
		const frontAltenStroke = front.current.querySelector('#front_svg__t-stroke')

		const hand = front.current.querySelector('#front_svg__hand')
		const heart = front.current.querySelector('#front_svg__heart')
		const pen = front.current.querySelector('#front_svg__pen')
		const battery = front.current.querySelector('#front_svg__batterie')

		const typoAll = [backF.children, backFStroke.children, backR.children, backE.children, backI.children, backIDot.children, frontEnt.children, frontEntStroke.children, frontF.children, frontAlten.children, frontAltenStroke.children]

		const typoTimeline = anime.timeline({
			autoplay: play,
			loop: true
		});

		typoTimeline
		.add({
			targets: [backF.children, backFStroke.children],
			easing: 'easeInSine',
			opacity: 1,
			delay: anime.stagger(1.2)
		})
		.add({
			targets: backR.children,
			easing: 'easeInSine',
			delay: anime.stagger(1.2),
			opacity: 1,
		}, '-=600')
		.add({
			targets: [backE.children, backI.children, backIDot.children],
			easing: 'easeInSine',
			delay: anime.stagger(1.2),
			opacity: 1,
		}, '-=1100')
		.add({
			targets: frontEnt.children,
			easing: 'easeInSine',
			delay: anime.stagger(1.2),
			opacity: 1,
		}, '-=800')
		.add({
			targets: frontEntStroke.children,
			easing: 'easeInSine',
			delay: anime.stagger(1.2),
			opacity: 1,
		}, '-=1000')
		.add({
			targets: frontF.children,
			easing: 'easeInSine',
			delay: anime.stagger(1.2),
			opacity: 1,
		}, '-=800')
		.add({
			targets: [frontAlten.children, frontAltenStroke.children],
			easing: 'easeInSine',
			delay: anime.stagger(1.2),
			opacity: 1,
		}, '-=800')
		.add({
			targets: typoAll,
			opacity: [1,0],
			easing: 'linear',
			duration: 1000,
			endDelay: 1000
		});

	anime({
		targets: hand,
		autoplay: play,
		duration: 6500,
		loop: true,
		direction: 'alternate',
		easing: 'easeInOutSine',
		keyframes: [
			{translateY: '0%', translateX: '0.78%'},
			{translateY: '0.4%', translateX: '0.35%'},
			{translateY: '0%', translateX: '0%'}
		]
	});
	anime({
		targets: heart,
		autoplay: play,
		duration: 4000,
		loop: true,
		direction: 'alternate',
		easing: 'easeInOutSine',
		keyframes: [
			{translateY: '0.8%', translateX: '0%'},
			{translateY: '0%', translateX: '0%'}
		]
	});
	anime({
		targets: pen,
		autoplay: play,
		duration: 5500,
		loop: true,
		direction: 'alternate',
		easing: 'easeInOutSine',
		keyframes: [
			{translateY: '1%', translateX: '-1.1%'},
			{translateY: '0%', translateX: '0%'}
		]
	});
	anime({
		targets: battery,
		autoplay: play,
		duration: 5000,
		loop: true,
		direction: 'alternate',
		easing: 'easeInOutSine',
		keyframes: [
			{translateY: '0.9%', translateX: '-0.9%'},
			{translateY: '0%', translateX: '0%'}
		]
	});

	// white backgrounds
	anime({
		targets: backAll,
		autoplay: play,
		duration: 5000,
		loop: true,
		direction: 'alternate',
		easing: 'easeInOutSine',
		keyframes: [
			{translateY: '0.2%', translateX: '-0.3%'},
			{translateY: '0%', translateX: '0%'}
		]
	});
	anime({
		targets: frontAll,
		autoplay: play,
		duration: 5000,
		loop: true,
		direction: 'alternate',
		easing: 'easeInOutSine',
		keyframes: [
			{translateY: '-0.4%', translateX: '-0.2%'},
			{translateY: '0%', translateX: '0%'}
		]
	});


	// twinkling
	anime({
		targets: [blackStar1, blackStar2, blackStar3, blackStar4, blackStar5],
		autoplay: play,
		duration: 4500,
		loop: true,
		delay: anime.stagger(600),
		easing: 'easeInOutSine',
		keyframes: [
			{opacity: 0.5},
			{opacity: 1}
		]
	});
	anime({
		targets: [star1.current, star2.current, star3.current, star4.current],
		autoplay: play,
		duration: 4500,
		loop: true,
		delay: anime.stagger(600),
		easing: 'easeInOutSine',
		keyframes: [
			{translateY: '-0.3%', translateX: '0.6%', scale: 0.5},
			{translateY: '0%', translateX: '0%', scale: 1}
		]
	});
	}, [play])
	return (
		<>
			<Back ref={back}/>
			<Front ref={front}/>
			<Star1 src={starSrc} ref={star1}/>
			<Star2 src={starSrc} ref={star2}/>
			<Star3 src={starSrc} ref={star3}/>
			<Star4 src={starSrc} ref={star4}/>
		</>
	)
};

export default KreativitaetStarten;